module.exports = __webpack_public_path__ + "static/media/MIC-Contestant.1b74f220.png";